<div class="list-wrapper">
  <div class="header">
    <div class="left">
      <button class="sidebar-toggle" mat-icon-button (click)="togglePipelineMenu()">
        <mat-icon [svgIcon]="'menu'"></mat-icon>
      </button>
      <div class="category">{{ pipeline.name }}</div>
    </div>
    <div class="main-actions">
      <project-list-header [pipeline]="pipeline"></project-list-header>

      <div class="projects-list-filter">
        <list-filter
          (projectFilters)="filterProjects($event)"
          (onClearFilters)="onClearFilters()"
          [queryFilters]="filter"
          [savedFilter]="savedFilter"
        ></list-filter>
      </div>
      <button
        [appAuthorize]="canAddDeal()"
        denyAction="disable"
        class="add-contact ml-2"
        [matMenuTriggerFor]="addProjectMenu"
        mat-flat-button
        [color]="'primary'"
        [disabled]="pipeline.pipeline_type === 'dynamic'"
      >
        <ng-container> <mat-icon [svgIcon]="'keyboard_arrow_down'"></mat-icon> Add </ng-container>
      </button>
      <mat-menu #addProjectMenu="matMenu">
        <button id="create-project" mat-menu-item (click)="openCustomDrawer()">
          <span class="ml-2"> <mat-icon svgIcon="add"></mat-icon> Enter Details </span>
        </button>
        <button mat-menu-item (click)="createProject()">
          <span class="ml-2"> <mat-icon [svgIcon]="'add'"></mat-icon> By Url </span>
        </button>
      </mat-menu>
    </div>
  </div>
  <div class="projects-list">
    <div class="table-wrapper flex flex-wrap w-full">
      <div class="flex flex-wrap w-3/4 lt-xl:w-full">
        <div class="inline-table-wrapper">
          <div class="button-toggle-wrapper mt-2 ml-2">
            <div>
              <mat-button-toggle-group class="tiers-selector" [value]="mapToggleVal" (change)="onChangeMapView($event)">
                <mat-button-toggle [value]="'deals'">Deals</mat-button-toggle>
                <mat-button-toggle [value]="'analytics'">Analytics</mat-button-toggle>
              </mat-button-toggle-group>
            </div>
            <div
              *ngIf="mapToggleVal === 'deals'"
              id="state-legend"
              class="legend"
              style="
                background-color: #fff;
                border-radius: 3px;
                bottom: 30px;
                box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
                font:
                  12px/20px 'Helvetica Neue',
                  Arial,
                  Helvetica,
                  sans-serif;
                padding: 10px;
                margin-top: 10px;
                z-index: 1;
              "
            >
              <div>
                <mat-form-field class="flex">
                  <mat-select [value]="groupBy" (selectionChange)="groupByChange($event)">
                    <mat-option *ngFor="let selectField of availableSelectFields" [value]="selectField.name">
                      {{ selectField.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div *ngFor="let group of groupByOptions; let i = index">
                <span
                  [style.background-color]="getColor(i, groupByOptions.length)"
                  style="border-radius: 50%; display: inline-block; height: 10px; margin-right: 5px; width: 10px"
                ></span
                >{{ groupName(group) }}
              </div>
              <div *ngIf="groupByOptions.length === 0">No options set</div>
            </div>
          </div>
          <div class="speed-dial-wrapper ml-2" *ngIf="mapToggleVal === 'analytics'">
            <mat-form-field>
              <mat-select placeholder="Select a filter" (selectionChange)="onMapFilterChange($event.value)">
                <mat-option
                  *ngFor="let type of dealMapFilters"
                  [disabled]="type.id === selectedSpeadDial"
                  [value]="type"
                  >{{ type.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <ng-container *ngIf="mapToggleVal === 'deals'">
            <mgl-map
              [style]="'mapbox://styles/mapbox/light-v10'"
              [zoom]="[4]"
              [minZoom]="4"
              [projection]="'mercator'"
              [center]="[-94.578331, 39.099724]"
              (moveEnd)="onMoveEnd()"
              (mapLoad)="onMapLoaded($event)"
            >
              <mgl-geojson-source id="projects" [data]="geoData" [generateId]="true"> </mgl-geojson-source>

              <div *ngIf="geoData">
                <ng-container *ngFor="let marker of filteredGeoJsonDataFeatures">
                  <mgl-marker #myMarker [lngLat]="marker.geometry.coordinates">
                    <div
                      [style.background-color]="getColor(getIndex(marker), groupByOptions.length)"
                      style="height: 10px; width: 10px; border-radius: 50%; display: inline-block"
                    ></div>
                  </mgl-marker>
                  <mgl-popup [marker]="myMarker">
                    <div class="flex flex-col max-w-80 w-full filter-article">
                      <a [routerLink]="['../' + marker.properties?.project_id]">
                        <img class="object-cover" src="{{ marker.properties?.icon }}" />
                      </a>
                      <div class="m-8">
                        <div class="text-2xl font-semibold leading-tight">
                          <a [routerLink]="['../' + marker.properties?.project_id]">{{ marker.properties?.title }}</a>
                        </div>
                        <div class="mt-4">
                          <div class="flex flex-wrap items-center text-secondary my-1">
                            <span>{{ marker.properties?.address }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </mgl-popup>
                </ng-container>
              </div>
              <mgl-popup *ngIf="selectedPoint" [lngLat]="selectedPoint.geometry?.coordinates">
                <div class="flex flex-col max-w-80 w-full filter-article">
                  <a [routerLink]="['../' + selectedPoint.properties?.project_id]">
                    <img class="object-cover" src="{{ selectedPoint.properties?.icon }}" />
                  </a>
                  <div class="m-8">
                    <div class="text-2xl font-semibold leading-tight">
                      <a [routerLink]="['../' + selectedPoint.properties?.project_id]">{{
                        selectedPoint.properties?.title
                      }}</a>
                    </div>
                    <div class="mt-4">
                      <div class="flex flex-wrap items-center text-secondary my-1">
                        <span>{{ selectedPoint.properties?.address }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </mgl-popup>
            </mgl-map>
          </ng-container>
          <ng-container *ngIf="mapToggleVal === 'analytics'">
            <mgl-map
              [style]="'mapbox://styles/mapbox/light-v10'"
              [zoom]="[4]"
              [minZoom]="4"
              [projection]="'mercator'"
              [center]="[-94.578331, 39.099724]"
              (moveEnd)="onMoveEnd()"
              (mapLoad)="onMapLoaded($event)"
            >
              <mgl-geojson-source id="projects" [data]="geoData" [generateId]="true"> </mgl-geojson-source>
              <mgl-layer
                id="projects"
                source="projects"
                type="circle"
                [filter]="['has', circleRadiusVar]"
                [paint]="{
                  'circle-radius': 15,
                  'circle-color': ['interpolate', ['linear'], ['get', circleRadiusVar], 0, 'green', 100, 'red'],
                }"
                (layerClick)="onClickAnalyticsPoint($event)"
                (layerMouseEnter)="cursorStyle = 'pointer'"
                (layerMouseLeave)="cursorStyle = ''"
              ></mgl-layer>
              <mgl-layer
                id="deal-count"
                type="symbol"
                source="projects"
                [filter]="['has', 'point_count']"
                [layout]="{
                  'text-field': '{point_count}',
                  'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
                  'text-size': 12,
                }"
                [paint]="{
                  'text-color': '#fff',
                }"
              >
              </mgl-layer>
              <mgl-popup *ngIf="selectedAnalyticsPoint" [lngLat]="selectedAnalyticsPoint.geometry?.coordinates">
                <div class="flex flex-col max-w-80 w-full filter-article">
                  <div class="m-1">
                    <div class="font-semibold leading-tight">{{ selectedAnalyticsPoint.properties?.name }}</div>
                    <div class="mt-2">
                      <div class="flex flex-wrap items-center text-secondary my-1">
                        <div
                          *ngIf="
                            selectedAnalyticsPoint.properties?.avg_bid_price &&
                            selectedAnalyticsPoint.properties?.avg_bid_price > 0
                          "
                        >
                          Avg. Bid Price:
                          {{ selectedAnalyticsPoint.properties?.avg_bid_price | tsCurrency: 'USD' : 'symbol' : '1.0' }}
                        </div>
                        <div
                          *ngIf="
                            selectedAnalyticsPoint.properties?.avg_price_per_unit &&
                            selectedAnalyticsPoint.properties?.avg_price_per_unit > 0
                          "
                        >
                          Avg. Bid Price/Unit:
                          {{
                            selectedAnalyticsPoint.properties?.avg_price_per_unit | tsCurrency: 'USD' : 'symbol' : '1.0'
                          }}
                        </div>
                        <div
                          *ngIf="
                            selectedAnalyticsPoint.properties?.avg_price_per_sq_ft &&
                            selectedAnalyticsPoint.properties?.avg_price_per_sq_ft > 0
                          "
                        >
                          Avg. Bid PSF:
                          {{
                            selectedAnalyticsPoint.properties?.avg_price_per_sq_ft
                              | tsCurrency: 'USD' : 'symbol' : '1.2-2'
                          }}
                        </div>
                        <div
                          *ngIf="
                            selectedAnalyticsPoint.properties?.avg_sale_price &&
                            selectedAnalyticsPoint.properties?.avg_sale_price > 0
                          "
                        >
                          Avg. Sale Price:
                          {{ selectedAnalyticsPoint.properties?.avg_sale_price | tsCurrency: 'USD' : 'symbol' : '1.0' }}
                        </div>
                        <div
                          *ngIf="
                            selectedAnalyticsPoint.properties?.avg_sale_price_per_unit &&
                            selectedAnalyticsPoint.properties?.avg_sale_price_per_unit > 0
                          "
                        >
                          Avg. Sale Price/Unit:
                          {{
                            selectedAnalyticsPoint.properties?.avg_sale_price_per_unit
                              | tsCurrency: 'USD' : 'symbol' : '1.0'
                          }}
                        </div>
                        <div
                          *ngIf="
                            selectedAnalyticsPoint.properties?.avg_sale_price_per_sq_ft &&
                            selectedAnalyticsPoint.properties?.avg_sale_price_per_sq_ft > 0
                          "
                        >
                          Avg. Sale PSF:
                          {{
                            selectedAnalyticsPoint.properties?.avg_sale_price_per_sq_ft
                              | tsCurrency: 'USD' : 'symbol' : '1.2-2'
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </mgl-popup>
            </mgl-map>
          </ng-container>
        </div>
      </div>
      <div class="flex flex-auto w-1/4 h-90">
        <div class="list-wrapper2">
          <app-map-deal-list
            [pipeline]="pipeline"
            [projects]="projects"
            [pagination]="pagination"
            [sortFields]="sortFields"
            [isLoading]="isLoading"
            [selectedSortField]="selectedSortField"
            (onPageChange)="onPageChange($event)"
            (onSelectSortOption)="onSelectSortOption($event)"
          ></app-map-deal-list>
        </div>
      </div>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
